var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAntDesignHomeFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5942 22.1923L23.4932 4.10446C23.3628 3.97387 23.208 3.87027 23.0376 3.79958C22.8672 3.72889 22.6845 3.6925 22.5 3.6925C22.3155 3.6925 22.1328 3.72889 21.9624 3.79958C21.792 3.87027 21.6372 3.97387 21.5068 4.10446L3.40576 22.1923C2.87842 22.7197 2.57959 23.436 2.57959 24.1831C2.57959 25.7343 3.84082 26.9956 5.39209 26.9956H7.29932V39.9023C7.29932 40.6801 7.92773 41.3086 8.70557 41.3086H19.6875V31.4648H24.6094V41.3086H36.2944C37.0723 41.3086 37.7007 40.6801 37.7007 39.9023V26.9956H39.6079C40.355 26.9956 41.0713 26.7011 41.5986 26.1694C42.6929 25.0708 42.6929 23.291 41.5942 22.1923Z",
    className: "svgText"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntDesignHomeFilled);
export default __webpack_public_path__ + "static/media/ant-design_home-filled.6501c2f4c1d389e5877d1d63016cf055.svg";
export { ForwardRef as ReactComponent };